// extracted by mini-css-extract-plugin
export var legendIndicator = "_dn-1";
export var legendRight = "_dn-0";